import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const ContenidoRow=({contenido, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{contenido.titulo}</Table.Cell>
                        <Table.Cell textAlign="center">{contenido.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/contenido/"+contenido.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link  size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
 								  
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link size="large"
                                            onClick={()=>onShowModalBorrar(contenido.id)} 
                                            color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
								 
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={contenido.idEstatus==1?'x':'check'} link  size="large"
                                                color={contenido.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(contenido.id)} 
                                            />
                                        }
                                        content={contenido.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
								  
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default ContenidoRow;